module.exports = __webpack_public_path__ + "static/media/party.0dc95066.jpg";